import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { ApiResponse } from '../models/api-response';
import { StudentMenuCounts, StudentProfile } from '../models/student-menu-counts';

@Injectable({ providedIn: 'root' })
export class StudentDashboardService {
  private baseUrl = `${environment.apiUrl}/StudentDashboard`;

  /** Cached per auth token, so a different login never sees the previous student's grade. */
  private profile$?: Observable<StudentProfile | null>;
  private profileToken: string | null = null;

  constructor(private http: HttpClient) {}

  getMenuCounts(): Observable<ApiResponse<StudentMenuCounts>> {
    return this.http.get<ApiResponse<StudentMenuCounts>>(`${this.baseUrl}/Counts`);
  }

  /** Source of truth for the signed-in student's grade placement (from the API, not localStorage). */
  getMyProfile(): Observable<StudentProfile | null> {
    const token = localStorage.getItem('authToken');
    if (!this.profile$ || this.profileToken !== token) {
      this.profileToken = token;
      this.profile$ = this.http.get<ApiResponse<StudentProfile>>(`${this.baseUrl}/MyProfile`).pipe(
        map(r => (r.isSuccess ? r.value ?? null : null)),
        catchError(() => {
          this.profile$ = undefined; // retry on the next call
          return of(null);
        }),
        shareReplay(1),
      );
    }
    return this.profile$;
  }

  /** The signed-in student's current grade id, or '' when none is assigned. */
  getMyGradeId(): Observable<string> {
    return this.getMyProfile().pipe(map(p => p?.gradeId ?? ''));
  }
}
